const isNullish = (value) => value === undefined || value === null;

export default isNullish;
